<template>
  <section >
    <template v-if="screen==0">
      <section class="bg-grey quicklink coloured-panel ">
        <div class="container py-1">
          <div class="row h-100 align-items-center justify-content-center">
            <div class="col-12 col-md-11 text-center">
              <h3 class="mb-4">{{ headingProp }}</h3>
              <div class="mb-4" v-html="textProp"></div>
            </div>
          </div>
        </div>
      </section>
      <div  class="container value-calculator company-size " >

        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>

        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-11 text-center">

            <h3 class="mb-5 pb-4">What size is your company?</h3>
            <div class="row justify-content-center">
              <div class="col-12 col-lg-9 text-center">
                <div class="sliderContainer mx-4">
                  <div class="min">$0m</div>
                  <div class="max">$2b+</div>
                  <vue-slider ref="companySize" v-model="companyTurnover"  :tooltip-formatter="q0format"  :min="0" :max="2000" :marks="{'500': '$500M' ,'1000': '$1B' ,'1500': '$1.5B'}" />
                </div>
              </div>
            </div>

            <p class="bold mb-5 mt-4 larger"><span class="text-yellow">{{ formatTurnover(companyTurnover) }}</span></p>
            <button @click="nextScreen" class="btn-grey btn btn-primary">Next</button>
          </div>
        </div>
      </div>
    </template>
    <div v-if="screen==1" class="value-calculator question" >
      <div class="container">
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center">
          <div class="col-12 col-xl-9 col-lg-10 col-md-11">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10 pt-md-3">
                <div class="question_container text-center">
                  <h3 class="text-turquoise">Close Period</h3>
                  <p>Doing a complete and accurate close each month is both a business necessity and often a lengthy activity. How much does the close period cost your company each month?</p>
                  <p class="semibold larger">How many days does your month-end close take?</p>
                </div>
              </div>
              <div class="col-12 bg-grey pb-4">
                <div class="sliderContainer">
                  <div class="min">0</div>
                  <div class="max">20</div>
                  <vue-slider v-model="data.closePeriod" ref="closePeriod" :tooltip-formatter="q1format" :min="0" :max="20"  :marks="[4, 8, 12, 16]" />
                </div>
                <div class="question_result_container">
                  <div class="row justify-content-center">
<!--                    <div class="col-12 col-sm-4 col-lg-3 text-center"><p>Employees:  </p><figure class="bold"  id="fig1"  v-tooltip:bottom="'This is an assumption based on your company size'">{{ base.companySize[data.companySize].periodClose }} <i class="far fa-question-circle"></i></figure>-->

<!--                    </div>-->
                    <div class="col-6 col-sm-4 col-lg-3 text-center text-turquoise "><p class="text-turquoise">Month Cost:</p><figure class="bold ">{{ formatPrice(closePeriodCost) }}</figure></div>
                    <div class="col-6 col-sm-4 col-lg-3 text-center text-turquoise bordered"><p class="text-turquoise">Fiscal Year Cost:</p><figure class="bold ">{{ formatPrice(closePeriodAnnualCost) }}</figure></div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-4 order-md-1 text-center">
                    <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" width="389.996" height="359" viewBox="30 27 300 310">
                      <g id="Group_944" data-name="Group 944" transform="translate(-1049.424 -1174.655)">
                        <g id="Ellipse_9" data-name="Ellipse 9" transform="matrix(0.215, -0.977, 0.977, 0.215, 1053, 1467.407)" fill="#ffffff" stroke="#c7c7c7" stroke-miterlimit="10" stroke-width="3">
                          <circle cx="146.509" cy="146.509" r="146.509" stroke="none"/>
                          <circle cx="146.509" cy="146.509" r="148.009" fill="none"/>
                        </g>
                        <circle id="Ellipse_10" data-name="Ellipse 10" cx="114.165" cy="114.165" r="114.165" transform="matrix(0.233, -0.972, 0.972, 0.233, 1089.985, 1440.287)" fill="#ededed"/>
                        <circle id="Ellipse_11" data-name="Ellipse 11" cx="77.758" cy="77.758" r="77.758" transform="translate(1117.734 1351.177) rotate(-42.548)" fill="#fff"/>
                        <circle id="Ellipse_12" data-name="Ellipse 12" cx="68.319" cy="68.319" r="68.319" transform="matrix(0.737, -0.676, 0.676, 0.737, 1131.075, 1351.663)" fill="none" stroke="#c7c7c7" stroke-miterlimit="10" stroke-width="1"/>

                        <text text-anchor="middle" id="_43_" data-name="43%" transform="translate(1228.694 1371.599)" fill="#5d5d5d" font-size="46" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="-0" y="0">
                          {{ this.closePeriodMonthPercent }}%</tspan></text>
                      </g>
                      <circle fill="transparent" stroke="#00a9ce" stroke-width="70" cy="181" cx="178" pathLength="100" r="111" class="donut-segment" :stroke-dasharray="this.closePeriodMonthPercent+' 100'"  transform="rotate(-90 178 181)"></circle>
                    </svg>
                    <p class="semibold text-center mt-3 mb-3 mb-md-0">of your month is spent <br>closing the books</p>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                    <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                    <button @click="nextScreen" class="next btn-grey btn btn-primary ">Next</button>
                  </div>
                </div>
              </div>
              <div class="gradient fact p-3 px-5 mt-2 text-center">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8">
                    <h3 class=" mb-2">Did you know?</h3>
                    <p class="">The 2022 SaaS Reporting Benchmark survey found that over <strong>50%</strong> of companies take <strong>2-3</strong> weeks to close their books at the end of the month</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen==2" class="value-calculator question" >
      <div class="container">
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center">
          <div class="col-12 col-xl-9 col-lg-10 col-md-11">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10 pt-md-3">
                <div class="question_container text-center">
                  <h3 class="text-turquoise">Reopening an accounting period</h3>
                  <p>Sometimes an accounting period needs to be reopened to correct significant errors, but what could that be costing your organization?</p>
                  <p class="semibold larger">How many times have you reopened an accounting period in the last year?</p>
                </div>
              </div>
              <div class="col-12 bg-grey pb-4">
                <div class="sliderContainer">
                  <div class="min">0</div>
                  <div class="max">12</div>
                  <vue-slider v-model="data.reopenAccountingPeriod" ref="reopenAccountingPeriod"  :tooltip-formatter="q2format"  :min="0" :max="12"  :marks="[2, 4, 6, 8,10]" />
                </div>
                <div class="question_result_container">
                  <div class="row justify-content-center">
<!--                    <div class="col-6 col-md-3 text-center"><p>Employees:</p><figure class="bold"  id="fig2"  v-tooltip:bottom="'This is an assumption based on your company size'">{{ base.reopenClosedPeople }} <i class="far fa-question-circle"></i></figure></div>-->
<!--                    <div class="col-6 col-md-3 text-center bordered"><p>Days for each period:</p><figure class="bold"  id="fig3"  v-tooltip:bottom="'This is an assumption based on your company size'">{{ base.reopenClosedDays }} <i class="far fa-question-circle"></i></figure></div>-->
                    <div class="col-6 col-md-3 text-center text-turquoise "><p class="text-turquoise">Reopened periods:</p><figure class="bold ">{{ data.reopenAccountingPeriod }}</figure></div>
                    <div class="col-6 col-md-3 text-center text-turquoise bordered"><p class="text-turquoise">Fiscal Year Cost:</p><figure class="bold ">{{ formatPrice(repoenClosedAnnualCost) }}</figure></div>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-12 col-md-4 order-md-1 text-center pt-2">
                    <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" width="380" height="420" viewBox="10 -20 210 370">
                      <defs>
                        <filter id="Ellipse_13" x="94.503" y="101.5" width="187" height="187" filterUnits="userSpaceOnUse">
                          <feOffset dx="5" dy="6" input="SourceAlpha"/>
                          <feGaussianBlur stdDeviation="4.5" result="blur"/>
                          <feFlood flood-opacity="0.263"/>
                          <feComposite operator="in" in2="blur"/>
                          <feComposite in="SourceGraphic"/>
                        </filter>
                      </defs>
                      <rect id="Rectangle_371" data-name="Rectangle 371" width="176" height="316" transform="translate(7.003)" fill="#E2E2E2"/>
                      <rect id="Rectangle_372" data-name="Rectangle 372" width="176" :height="repoenCostPercent * 3.16"
                            :transform="`translate(7.003 ${316 - (repoenCostPercent * 3.16)})`" fill="#00a9ce"/>

                      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_13)">
                        <circle id="Ellipse_13-2" data-name="Ellipse 13" cx="80" cy="80" r="80" transform="translate(103 109)" fill="#fff"/>
                      </g>
                      <text text-anchor="middle" id="_12_701" data-name="$12,701" transform="translate(186.503 201.5)" fill="#5d5d5d" font-size="32" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="0" y="0">{{ formatPrice(repoenClosedAnnualCost) }}</tspan></text>
                      <line id="Line_40" data-name="Line 40" x2="19.503" transform="translate(7 170.803)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_41" data-name="Line 41" x2="19.503" transform="translate(7 142.214)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_50" data-name="Line 50" x2="19.503" transform="translate(7 282.141)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_44" data-name="Line 44" x2="19.503" transform="translate(7 85.037)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_48" data-name="Line 48" x2="19.503" transform="translate(7 227.979)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_42" data-name="Line 42" x2="19.503" transform="translate(7 113.625)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_49" data-name="Line 49" x2="19.503" transform="translate(7 255.538)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_43" data-name="Line 43" x2="19.503" transform="translate(7 59.463)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_47" data-name="Line 47" x2="19.503" transform="translate(7 199.391)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_45" data-name="Line 45" x2="19.503" transform="translate(7 27.859)" fill="none" stroke="#fff" stroke-width="5"/>
                    </svg>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                    <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                    <button @click="nextScreen" class="next btn-grey btn btn-primary ">Next</button>
                  </div>
                </div>
              </div>

              <div class="gradient fact p-3 px-5 mt-2 text-center">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8">
                    <h3 class="mb-2">Did you know?</h3>
                    <p class="">In a study by The University of Georgia’s Consumer Analytics program, <strong>85%</strong> of participants reported having to re-open their books in at least one month over the last year</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen==3" class="value-calculator question" >
      <div class="container">
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center">
          <div class="col-12 col-xl-9 col-lg-10 col-md-11">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10 pt-md-3">
                <div class="question_container text-center">
                  <h3 class="text-turquoise">Spreadsheet errors</h3>
                  <p>Most businesses use official and unofficial spreadsheets to get a complete picture of their finances.</p>
                  <p class="semibold larger">How many financial spreadsheets does your company work with each month?</p>
                </div>
              </div>
              <div class="col-12 bg-grey pb-4">
                <div class="sliderContainer">
                  <div class="min">0</div>
                  <div class="max">5000</div>
                  <vue-slider v-model="data.spreadsheets" ref="spreadsheets" :min="0" :max="5000"  :tooltip-formatter="q3format"  :marks="[1000, 2000, 3000, 4000]"/>
                </div>
                <div class="question_result_container">
                  <div class="row justify-content-center">
<!--                    <div class="col-6 col-md-3 text-center"><p>Errors per spreadsheet:</p><figure class="bold"  id="fig4"  v-tooltip:bottom="'This is an assumption based on your company size'">{{ base.spreadsheetErrorCount }} <i class="far fa-question-circle"></i></figure></div>-->
<!--                    <div class="col-6 col-md-3 text-center bordered"><p class="">Spreadsheets with errors:</p><figure class="bold "  id="fig5"  v-tooltip:bottom="'This is an assumption based on your company size'">{{ base.spreadsheetErrorPercent }}% <i class="far fa-question-circle"></i></figure></div>-->
                    <div class="col-6 col-md-3 text-center  text-turquoise"><p class="text-turquoise">Spreadsheets:</p><figure class="bold ">{{ data.spreadsheets }}</figure></div>
                    <div class="col-6 col-md-3 text-center bordered text-turquoise"><p class="text-turquoise">Fiscal Year Cost:</p><figure class="bold ">{{ formatPrice(spreadsheetErrorAnnualCost) }}</figure></div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-sm-9 text-center pt-3 pb-4">
                    <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" width="685.064" height="213.744" viewBox="0 0 685.064 213.744">
                      <g id="Group_989" data-name="Group 989" transform="translate(-617.468 -512.614)">
                        <g id="Rectangle_432" data-name="Rectangle 432" transform="translate(617.468 512.614)" fill="none" stroke="#71ab9f" stroke-width="2">
                          <rect width="685.064" height="102.877" stroke="none"/>
                          <rect x="1" y="1" width="683.064" height="100.877" fill="none"/>
                        </g>
                        <text id="_1_672_of_your_spreadsheets_likely_contain_errors" data-name="1,672
of your spreadsheets likely contain errors" transform="translate(808.639 515.714)" fill="#71ab9f" font-size="31" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="113.851" y="49">{{ Math.round(spreadsheetsWithErrors) }}</tspan><tspan y="49" fill="#fff" font-size="53"> </tspan><tspan fill="#333" font-size="14" font-family="ProximaNova-Medium, Proxima Nova" font-weight="500"><tspan x="23.807" y="74">of your spreadsheets likely contain errors</tspan></tspan></text>
                        <path id="Path_592" data-name="Path 592" d="M4096.157,29.293V60.122a1.705,1.705,0,0,1-1.738,1.071q-9.268-.02-18.538-.007c-.6,0-.612.015-.613.6,0,1.2,0,2.4,0,3.6a1.574,1.574,0,0,1-2.084,1.723q-5.341-1-10.682-2-6.419-1.2-12.834-2.417a1.539,1.539,0,0,1-1.375-1.662q0-16.32,0-32.64c0-.062,0-.124,0-.187a1.484,1.484,0,0,1,.44-1,2.158,2.158,0,0,1,1.307-.548l14.258-2.674q4.493-.843,8.987-1.681a1.551,1.551,0,0,1,1.982,1.657c0,1.136,0,2.273,0,3.409,0,.873,0,.873.851.873q9.152,0,18.3-.007A1.691,1.691,0,0,1,4096.157,29.293Zm-23.951,15.413q0-9.224,0-18.448c0-.578-.02-.6-.576-.5q-9.861,1.841-19.721,3.679c-.446.083-.565.281-.564.719q.018,14.525.009,29.05c0,.657,0,.656.65.776q2.454.456,4.907.916,7.269,1.363,14.537,2.726c.759.142.76.136.76-.66Zm20.926.027v-12.8c0-.643,0-.645-.659-.645h-11.49c-1.728,0-3.456.01-5.184-.007-.411,0-.553.143-.538.546.024.606.028,1.215,0,1.821-.02.433.141.571.569.564,1.245-.021,2.49-.01,3.736,0a2.221,2.221,0,0,1,.6.064,1.509,1.509,0,0,1,1.069,1.7,1.493,1.493,0,0,1-1.444,1.286q-1.985.029-3.969,0c-.438-.007-.578.151-.559.574.028.606.026,1.215,0,1.821-.016.413.146.543.547.537,1.26-.018,2.522-.01,3.783,0a1.534,1.534,0,1,1-.014,3.058c-1.261.005-2.522.011-3.783,0-.371,0-.545.1-.531.5.022.638.021,1.277,0,1.915-.013.394.148.514.525.51,1.261-.015,2.522-.008,3.783,0a2.191,2.191,0,0,1,.6.066,1.525,1.525,0,0,1-.386,2.984q-1.984.028-3.969,0c-.394,0-.57.111-.553.531.026.622.026,1.246,0,1.868-.017.419.157.537.552.531,1.245-.017,2.492-.009,3.737,0a2.305,2.305,0,0,1,.6.059,1.527,1.527,0,0,1-.393,2.993q-1.984.025-3.97,0c-.376,0-.541.115-.526.509.022.591,0,1.183.006,1.775,0,.628.01.638.618.638h16.628c.608,0,.617-.01.618-.639Z" transform="translate(-3410.157 519.582)" fill="#71ab9f"/>
                        <g id="Rectangle_433" data-name="Rectangle 433" transform="translate(617.468 623.991)" fill="none" stroke="#5397da" stroke-width="2">
                          <rect width="336.647" height="102.367" stroke="none"/>
                          <rect x="1" y="1" width="334.647" height="100.367" fill="none"/>
                        </g>
                        <g id="Rectangle_434" data-name="Rectangle 434" transform="translate(964.851 623.991)" fill="none" stroke="#4fa7ca" stroke-width="2">
                          <rect width="336.646" height="102.367" stroke="none"/>
                          <rect x="1" y="1" width="334.646" height="100.367" fill="none"/>
                        </g>
                        <text id="_3_344" data-name="3,344" transform="translate(691.881 665.859)" fill="#5397da" font-size="31" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="0" y="29">{{ Math.round(spreadsheetsWithErrors * base.spreadsheetErrorCount) }}</tspan></text>
                        <text id="_474" data-name="474" transform="translate(1049.5 665.859)" fill="#4fa7ca" font-size="31" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="0" y="29">
                          {{ Math.round(spreadsheetTimeToFix) }}</tspan></text>
                        <text id="Estimated_error_count_to_date" data-name="Estimated error count to date" transform="translate(691.881 648.359)" fill="#333" font-size="14" font-family="ProximaNova-Medium, Proxima Nova" font-weight="500"><tspan x="0" y="13">Estimated error count to date</tspan></text>
                        <text id="Estimated_hours_to_fix_errors" data-name="Estimated hours to fix errors" transform="translate(1049.5 648.359)" fill="#333" font-size="14" font-family="ProximaNova-Medium, Proxima Nova" font-weight="500"><tspan x="0" y="13">Estimated hours to fix errors</tspan></text>
                        <g id="Group_987" data-name="Group 987" transform="translate(438.574 615.094)">
                          <circle id="Ellipse_15" data-name="Ellipse 15" cx="19.333" cy="19.333" r="19.333" transform="translate(194.635 40.748)" fill="none" stroke="#5397da" stroke-width="2.5"/>
                          <g id="Group_952" data-name="Group 952" transform="translate(206.391 52.504)">
                            <g id="Group_950" data-name="Group 950" transform="translate(0 0)">
                              <path id="Path_568" data-name="Path 568" d="M225.848,85.26a1.857,1.857,0,0,1-1.313-3.169l11.442-11.442a1.856,1.856,0,1,1,2.625,2.625L227.161,84.716A1.849,1.849,0,0,1,225.848,85.26Z" transform="translate(-223.992 -70.105)" fill="#5397da"/>
                            </g>
                            <g id="Group_951" data-name="Group 951" transform="translate(0 0)">
                              <path id="Path_569" data-name="Path 569" d="M237.291,85.26a1.85,1.85,0,0,1-1.313-.544L224.536,73.274a1.856,1.856,0,1,1,2.625-2.625L238.6,82.091a1.857,1.857,0,0,1-1.313,3.169Z" transform="translate(-223.992 -70.105)" fill="#5397da"/>
                            </g>
                          </g>
                        </g>
                        <g id="Group_988" data-name="Group 988" transform="translate(875.592 377.779)">
                          <g id="Group_958" data-name="Group 958" transform="translate(111.021 277.08)">
                            <g id="Group_955" data-name="Group 955" transform="translate(0)">
                              <path id="Path_570" data-name="Path 570" d="M131.717,318.471a20.7,20.7,0,1,1,19.441-27.807l-2.913,1.065a17.6,17.6,0,1,0-3.066,17.375l2.372,2A20.663,20.663,0,0,1,131.717,318.471Z" transform="translate(-111.021 -277.08)" fill="#4fa7ca"/>
                            </g>
                            <g id="Group_957" data-name="Group 957" transform="translate(33.684 11.894)">
                              <g id="Group_956" data-name="Group 956">
                                <path id="Path_571" data-name="Path 571" d="M176.185,301.951l6.156,6.941,2.934-8.8Z" transform="translate(-176.185 -300.09)" fill="#4fa7ca"/>
                              </g>
                            </g>
                          </g>
                          <g id="Group_959" data-name="Group 959" transform="translate(128.904 295.48)">
                            <path id="Path_572" data-name="Path 572" d="M151.243,315.487a2.813,2.813,0,1,1-2.813-2.812A2.813,2.813,0,0,1,151.243,315.487Z" transform="translate(-145.617 -312.675)" fill="#4fa7ca"/>
                          </g>
                          <g id="Group_960" data-name="Group 960" transform="translate(130.136 287.377)">
                            <path id="Path_573" data-name="Path 573" d="M161.916,312.631,148,309.058V297h3.1v9.652l11.586,2.975Z" transform="translate(-148 -297)" fill="#4fa7ca"/>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                    <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                    <button @click="nextScreen" class="next btn-grey btn btn-primary ">Next</button>
                  </div>
                </div>
              </div>

              <div class="gradient fact p-3 px-5 mt-2 text-center">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8">
                    <h3 class=" mb-2">Did you know?</h3>
                    <p class="">Consulting firm F1F9 estimates that <strong>88%</strong> of all spreadsheets have errors and <strong>50%</strong> of spreadsheets used by large corporations have material defects.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen==4" class="value-calculator question" >
      <div class="container">
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center">
          <div class="col-12 col-xl-9 col-lg-10 col-md-11">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10 pt-md-3">
                <div class="question_container text-center">
                  <h3 class="text-turquoise">Reports</h3>
                  <p>Many companies have collected hundreds if not thousands of reports from different solutions that are needed monthly to provide accurate financial insight.  What does this reporting activity cost your company?</p>
                  <p class="semibold larger">How many reports do you run and maintain each month?</p>
                </div>
              </div>
              <div class="col-12 bg-grey pb-4">
                <div class="sliderContainer">
                  <div class="min">0</div>
                  <div class="max">1000</div>
                  <vue-slider v-model="data.reports" ref="reports" :min="0" :max="1000"  :tooltip-formatter="q4format"  :marks="[200, 400, 600, 800]" />
                </div>
                <div class="question_result_container">
                  <div class="row justify-content-center">
<!--                    <div class="col-12 col-sm-4 col-lg-3 text-center"><p>Hours per report:</p><figure class="bold"  id="fig6"  v-tooltip:bottom="'This is an assumption based on your company size'">{{ base.reportMaintenanceHours }} <i class="far fa-question-circle"></i></figure></div>-->
                    <div class="col-6 col-sm-4 col-lg-3 text-center text-turquoise "><p class="text-turquoise">Reports:</p><figure class="bold ">{{ data.reports }}</figure></div>
                    <div class="col-6 col-sm-4 col-lg-3 text-center text-turquoise bordered"><p class="text-turquoise">Monthly Cost:</p><figure class="bold ">{{ formatPrice(reportsMonthlyCost) }}</figure></div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-4 order-md-1 text-center">
                    <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" width="380" height="420" viewBox="10 -20 210 370">
                      <defs>
                        <filter id="Ellipse_13" x="94.503" y="101.5" width="187" height="187" filterUnits="userSpaceOnUse">
                          <feOffset dx="5" dy="6" input="SourceAlpha"/>
                          <feGaussianBlur stdDeviation="4.5" result="blur"/>
                          <feFlood flood-opacity="0.263"/>
                          <feComposite operator="in" in2="blur"/>
                          <feComposite in="SourceGraphic"/>
                        </filter>
                      </defs>
                      <rect id="Rectangle_371" data-name="Rectangle 371" width="176" height="316" transform="translate(7.003)" fill="#E2E2E2"/>
                      <rect id="Rectangle_372" data-name="Rectangle 372" width="176" :height="reportsPercent * 3.16"
                            :transform="`translate(7.003 ${316 - (reportsPercent * 3.16)})`" fill="#00a9ce"/>

                      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_13)">
                        <circle id="Ellipse_13-2" data-name="Ellipse 13" cx="80" cy="80" r="80" transform="translate(103 109)" fill="#fff"/>
                      </g>
                      <text text-anchor="middle" id="_12_701" data-name="$12,701" transform="translate(186.503 201.5)" fill="#5d5d5d" font-size="32" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="0" y="0">{{ formatPrice(reportsMonthlyCost) }}</tspan></text>
                      <line id="Line_40" data-name="Line 40" x2="19.503" transform="translate(7 170.803)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_41" data-name="Line 41" x2="19.503" transform="translate(7 142.214)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_50" data-name="Line 50" x2="19.503" transform="translate(7 282.141)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_44" data-name="Line 44" x2="19.503" transform="translate(7 85.037)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_48" data-name="Line 48" x2="19.503" transform="translate(7 227.979)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_42" data-name="Line 42" x2="19.503" transform="translate(7 113.625)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_49" data-name="Line 49" x2="19.503" transform="translate(7 255.538)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_43" data-name="Line 43" x2="19.503" transform="translate(7 59.463)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_47" data-name="Line 47" x2="19.503" transform="translate(7 199.391)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_45" data-name="Line 45" x2="19.503" transform="translate(7 27.859)" fill="none" stroke="#fff" stroke-width="5"/>
                    </svg>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                    <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                    <button @click="nextScreen" class="next btn-grey btn btn-primary ">Next</button>
                  </div>
                </div>
              </div>

              <div class="gradient fact p-3 px-5 mt-2 text-center">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8">
                  <h3 class=" mb-2">Did you know?</h3>
                  <p class="">According to BusinessWire’s 2021 executive survey, only <strong>33.9%</strong> of companies are managing data as an asset.</p>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen==5" class="value-calculator question" >
      <div class="container">
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center">
          <div class="col-12 col-xl-9 col-lg-10 col-md-11">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10 pt-md-3">
                <div class="question_container text-center">
                  <h3 class="text-turquoise">Automating manual accounting tasks</h3>
                  <p>The cost for closing a period and other core accounting activities is typically impacted by an overabundance of manual tasks. </p>
                  <p class="semibold larger">What percentage of your AP/AR team's tasks do you think could be automated that are not today?</p>
                </div>
              </div>
              <div class="col-12 bg-grey pb-4">
                <div class="sliderContainer">
                  <div class="min">0</div>
                  <div class="max">100%</div>
                  <vue-slider v-model="data.automation" ref="automation"  :min="0" :max="100"   :tooltip-formatter="q5format"  :marks="[20, 40, 60, 80]" />
                </div>
                <div class="question_result_container">
                  <div class="row justify-content-center">
                    <div class="col-6 col-sm-4 col-lg-3 text-center text-turquoise"><p class="text-turquoise">Automation of tasks:</p><figure class="bold ">{{ data.automation }}%</figure></div>
                    <div class="col-6 col-sm-4 col-lg-3 text-center text-turquoise bordered"><p class="text-turquoise">Monthly Savings:</p><figure class="bold ">{{ formatPrice(automationMonthlyCost) }}</figure></div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-4 order-md-1 text-center">
                    <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" width="389.996" height="359" viewBox="30 27 300 310">
                      <g id="Group_944" data-name="Group 944" transform="translate(-1049.424 -1174.655)">
                        <g id="Ellipse_9" data-name="Ellipse 9" transform="matrix(0.215, -0.977, 0.977, 0.215, 1053, 1467.407)" fill="#ffffff" stroke="#c7c7c7" stroke-miterlimit="10" stroke-width="3">
                          <circle cx="146.509" cy="146.509" r="146.509" stroke="none"/>
                          <circle cx="146.509" cy="146.509" r="148.009" fill="none"/>
                        </g>
                        <circle id="Ellipse_10" data-name="Ellipse 10" cx="114.165" cy="114.165" r="114.165" transform="matrix(0.233, -0.972, 0.972, 0.233, 1089.985, 1440.287)" fill="#ededed"/>
                        <circle id="Ellipse_11" data-name="Ellipse 11" cx="77.758" cy="77.758" r="77.758" transform="translate(1117.734 1351.177) rotate(-42.548)" fill="#fff"/>
                        <circle id="Ellipse_12" data-name="Ellipse 12" cx="68.319" cy="68.319" r="68.319" transform="matrix(0.737, -0.676, 0.676, 0.737, 1131.075, 1351.663)" fill="none" stroke="#c7c7c7" stroke-miterlimit="10" stroke-width="1"/>

                        <text text-anchor="middle" id="_43_" data-name="43%" transform="translate(1228.694 1371.599)" fill="#5d5d5d" font-size="46" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="-0" y="0">
                          {{ data.automation }}%</tspan></text>
                      </g>
                      <circle fill="transparent" stroke="#00a9ce" stroke-width="70" cy="181" cx="178" pathLength="100" r="111" class="donut-segment" :stroke-dasharray="data.automation+' 100'"  transform="rotate(-90 178 181)"></circle>
                    </svg>
                    <p class="semibold text-center mt-3 mb-3 mb-md-0">of current manual tasks <br>could be automated</p>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                    <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                  </div>
                  <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                    <button @click="nextScreen();submit();" class="next btn-grey btn btn-primary ">Next</button>
                  </div>
                </div>
              </div>

              <div class="gradient fact p-3 px-5 mt-2 text-center">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8">
                    <h3 class=" mb-2">Did you know?</h3>
                    <p class="">Manual accounting closure requires considerable human capital. McKinsey showed that <strong>45%</strong> of current paid activities can potentially be automated</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen==6" class="value-calculator result bg-turquoise" >
      <div class="container ">
        <div class="box">
          <div class="row  justify-content-center">
            <div class="col-11 col-md-8 text-center">
              <h5>YOUR RESULTS</h5>
              <p>
                The estimated annual cost of your current financial processes is <span class="bold text-darkblue">{{ formatPrice(totalAnnualCost) }}</span>  based on a labor rate of <span class="text-darkblue">{{ formatPrice(base.laborPerHour) }}</span>  per hour or about
                <span class="bold text-darkblue">{{ totalEmployees }}</span>  FTEs.
              </p>
              <div class="row">
                <div class="col-12">
                  <p>Access your personalized report for more details.</p>
                  <button class="btn btn-primary btn-darkblue"  data-toggle="modal" data-target="#pdf-modal">Download the PDF</button>
                </div>
              </div>
<!--              <button class="btn btn-primary btn-darkblue">Download PDF </button>-->
              <input type="hidden" :value="submissionId" id="submissionId">
            </div>
          </div>
        </div>
        <div class="box cta mt-3">
          <div class="row  justify-content-center">
            <div class="col-11 col-md-8 text-center">
              <p>We made assumptions in building this calculator. If you’d like to get a tailored version of this calculation for your company, we can do so on a 10-min call.</p>
              <a class="btn btn-primary btn-darkblue" href="https://www.nextw.com/schedule-a-call">Schedule a Call</a>
            </div>
          </div>
        </div>
    </div>
    </div>

  </section>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'


export default {
  components: {
    VueSlider,
  },
  props:[
    'workdayHoursProp','workMonthDaysProp','payPerHourProp','benefitPercentProp','reopenClosedPeopleProp','reopenClosedDaysProp','spreadsheetErrorPercentProp','spreadsheetMinsPerErrorProp','spreadsheetErrorCountProp','reportMaintenanceHoursProp','companySizeProp','headingProp','textProp'
  ],
  data() {

    var  workDayHours = this.workdayHoursProp;
    var  workMonthDays = this.workMonthDaysProp;
    var  payPerHour = this.payPerHourProp;
    var  benefitPercent = this.benefitPercentProp;
    var  labourRate = payPerHour * (1 + (benefitPercent / 100));

    var companySizes = {
    Small: {
        periodClose: this.companySizeProp[0].periodClose,
        finance: this.companySizeProp[0].financeTeam,
        arAp: this.companySizeProp[0].arApTeam,
      },
      Medium:{
        periodClose: this.companySizeProp[1].periodClose,
        finance: this.companySizeProp[1].financeTeam,
        arAp: this.companySizeProp[1].arApTeam,
      },
      Large:{
        periodClose: this.companySizeProp[2].periodClose,
        finance: this.companySizeProp[2].financeTeam,
        arAp: this.companySizeProp[2].arApTeam,
      }
    }

    return {
      companyTurnover:1000,
      submissionId: 0,
      mousedown: '',
      screen:0,
      base: {
        laborPerHour: labourRate,
        workDayHours: workDayHours,
        workMonthDays: workMonthDays,
        annualSalary:  workDayHours * 5 * 52 * labourRate,
        reopenClosedPeople: this.reopenClosedPeopleProp,
        reopenClosedDays: this.reopenClosedDaysProp,
        spreadsheetErrorPercent: this.spreadsheetErrorPercentProp,
        spreadsheetMinsPerError: this.spreadsheetMinsPerErrorProp,
        spreadsheetErrorCount: this.spreadsheetErrorCountProp,
        reportMaintenanceHours: this.reportMaintenanceHoursProp,

        companySize:companySizes,
      },
      data: {
        companySize:"Small",
        closePeriod:10,
        reopenAccountingPeriod:6,
        spreadsheets:2500,
        reports:500,
        automation:50,
      },
      q0format: function (value){
        var unit = 'M';
        if(value >= 1000){
          value = value / 1000;
          value = value.toFixed(1);
          unit = 'B';
        }
        return '$'+value+unit;
      },
      q1format: '{value} days',
      q2format: '{value} times',
      q3format: '{value} spreadsheets',
      q4format: '{value} reports',
      q5format: '{value}%',
    }
  },
  watch:{
    companyTurnover(newVal, oldVal) {
      if(newVal < 75){
        this.data.companySize = 'Small'
      }else if (newVal < 500){
        this.data.companySize = 'Medium'
      }else{
        this.data.companySize = 'Large'
      }
    }
  },
  computed:{
    closePeriodMonthPercent: function (){
      return Math.round((this.data.closePeriod / this.base.workMonthDays) * 100)
    },
    closePeriodPeopleDays: function (){
      return this.base.companySize[this.data.companySize].periodClose * this.data.closePeriod;
    },
    closePeriodCost: function (){
      return this.closePeriodPeopleDays * this.base.workDayHours * this.base.laborPerHour;
    },
    closePeriodAnnualCost: function (){
      return this.closePeriodCost * 12;
    },
    repoenCostPercent: function (){
      return this.data.reopenAccountingPeriod / 12 * 100 //12 months
    },
    repoenClosedMonthyCost: function (){
      return this.base.reopenClosedPeople * this.base.reopenClosedDays * this.base.workDayHours * this.base.laborPerHour;
    },
    repoenClosedAnnualCost: function (){
      return this.repoenClosedMonthyCost * this.data.reopenAccountingPeriod;
    },
    spreadsheetsWithErrors: function (){
      return this.data.spreadsheets * (this.base.spreadsheetErrorPercent / 100)
    },
    spreadsheetTimeToFix: function (){
      return (this.spreadsheetsWithErrors * this.base.spreadsheetMinsPerError / 60); // 60 mins in hour
    },
    spreadsheetErrorMonthlyCost: function (){
      return this.spreadsheetTimeToFix * this.base.laborPerHour;
    },
    spreadsheetErrorAnnualCost: function (){
      return this.spreadsheetErrorMonthlyCost * 12;
    },
    reportsPercent: function (){
      return  this.data.reports / 1000 * 100; //1000 max for slider
    },
    reportsMonthlyCost: function (){
      return  this.base.reportMaintenanceHours * this.base.laborPerHour * this.data.reports;
    },
    reportsAnnualCost: function (){
      return this.reportsMonthlyCost * 12;
    },
    automationPeople: function (){
      return this.base.companySize[this.data.companySize].arAp;
    },
    automationMonthlyCost: function (){
      return  (this.data.automation / 100) * this.base.workMonthDays * this.base.workDayHours * this.base.laborPerHour * this.automationPeople;
    },
    automationAnnualCost: function (){
      return this.automationMonthlyCost * 12;
    },
    totalAnnualCost: function (){
      return this.automationAnnualCost + this.reportsAnnualCost + this.spreadsheetErrorAnnualCost + this.repoenClosedAnnualCost + this.closePeriodAnnualCost;
    },
    totalEmployees: function (){
      return Math.round(this.totalAnnualCost / this.base.annualSalary);
    }
  },
  methods: {
    formatTurnover(value) {
      if(value == 0 ) {
        return 'less than $1M'
      }else if(value > 1950 ) {
        return '$2B and over'
      }else if(value == 1000 ) {
        return '$1B';
      }else if(value < 1000 ){
        return '$'+value+'M'
      }else if(value < 1100 ){
        return '$1B';
      }else{
        var calc = value/1000;
        return '$'+calc.toFixed(1)+'B'
      }
    },
    submit() {
      var self = this;
      axios.post('/actions/valuecalc/valuecalc/save', {
        data: this.data,
        store: {
          companyTurnover: this.formatTurnover(this.companyTurnover),
          closePeriodMonthPercent: this.closePeriodMonthPercent,
          closePeriodPeopleDays: this.closePeriodPeopleDays,
          closePeriodCost: this.closePeriodCost,
          closePeriodAnnualCost: this.closePeriodAnnualCost,
          repoenCostPercent: this.repoenCostPercent,
          repoenClosedMonthyCost: this.repoenClosedMonthyCost,
          repoenClosedAnnualCost: this.repoenClosedAnnualCost,
          spreadsheetsWithErrors: this.spreadsheetsWithErrors,
          spreadsheetTimeToFix: this.spreadsheetTimeToFix,
          spreadsheetErrorMonthlyCost: this.spreadsheetErrorMonthlyCost,
          reportsPercent: this.reportsPercent,
          reportsMonthlyCost: this.reportsMonthlyCost,
          reportsAnnualCost: this.reportsAnnualCost,
          automationPeople: this.automationPeople,
          automationMonthlyCost: this.automationMonthlyCost,
          automationAnnualCost: this.automationAnnualCost,
          totalAnnualCost: this.totalAnnualCost,
          totalEmployees: this.totalEmployees,
        },
        result_cost: this.totalAnnualCost,
        result_fte: this.totalEmployees,
      })
      .then(function (response) {
        self.submissionId = response.data.id;
        $('input[name="cost_calculator_report_pdf"]').val("https://nextw.com/actions/valuecalc/valuecalc/pdf?id="+self.submissionId);

        console.log(response.data.id);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return '$'+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    nextScreen(){
      this.screen ++;
      var nav = $('header').height();
      var offset = $('#app').offset();
      var position = offset.top - nav ;
      if(this.screen  < 6){
        position = position + 30;
      }
      $('[data-toggle="tooltip"]').tooltip('dispose');
      this.$forceUpdate();

      $('html,body').animate({'scrollTop': position},300)
    },
    prevScreen(){
      this.screen --;
      $('[data-toggle="tooltip"]').tooltip('dispose');
      this.$forceUpdate();
    },
    goToScreen(screen){
      this.screen = screen;
      $('[data-toggle="tooltip"]').tooltip('dispose');
      this.$forceUpdate();
    },
    sliderDown(ref,direction){
      var self = this;
      this.adjustSlider(ref,direction);
      this.mousedown = setInterval(function (){
        self.adjustSlider(ref,direction);
      },500);
    },
    sliderUp(){
      clearInterval(this.mousedown);
    },
    adjustSlider(ref,direction){
      var current = this.$refs[ref].getIndex();
      if(direction == 'increase'){
        current++;
      }else{
        current--;
      }
      this.$refs[ref].setIndex(current);
    }
  }
}
</script>